import UltMeta, { Meta } from "@/meta/UltMeta/index";

class PaymentType extends UltMeta {
    BOTTOM_TO_TOP = new Meta(1, "供应商-采购商");
    BOTTOM_TO_MEDIUM = new Meta(2, "联合购销商-采购商");
    MEDIUM_TO_TOP = new Meta(3, "供应商-联合购销商");
}
export const PAYMENT_TYPE = new PaymentType();

class PaymentState extends UltMeta {
    CONFIRMING = new Meta(1, "确认中");
    DONE = new Meta(2, "已完成");
    REJECTED = new Meta(3, "已驳回");
    INVALIDING = new Meta(4, "作废中");
    INVALID = new Meta(5, "已作废");
}
export const PAYMENT_STATE = new PaymentState();

class PaymentMode extends UltMeta {
    CASH = new Meta(1, "现金");
    LETTER_OF_CREDIT = new Meta(2, "信用证");
    BANK_ACCEPTANCE_BILLS = new Meta(3, "银行承兑汇票");
    PAYMENT_OF_COMMERCIAL_ACCEPTANCE_BILLS = new Meta(4, "商业承兑汇票付款");
    BANK_TRANSFER = new Meta(5, "银行转账");
}

export const PAYMENT_MODE = new PaymentMode();
